export default __webpack_public_path__ + "static/media/logo_header.5be75c03.png";